const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'faqcategory/CREATE',
  EDIT: 'faqcategory/EDIT'
}

export default actions
